import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'
import { Loading } from 'element-ui';

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 100000 // request timeout
})

let loadingInstance = null;

// 提示
const handleMessage = (msg, type) => {
  Message({
    message: msg || 'Error',
    type,
    duration: 3000
  });
};


service.interceptors.request.use(
  config => {
    config.headers['tokenu'] = localStorage.getItem('tokenu') //用户token
    config.headers['tokena'] = localStorage.getItem('tokena') // 管理员token
    config.headers['domain'] = process.env.VUE_APP_BASE_API // 域名
    if (config.loading) {
      loadingInstance = Loading.service(
        {
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        }
      );
    }

    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    if (loadingInstance) {
      loadingInstance.close()
    }



    if (!response.data) {
      handleMessage('服务端无响应', 'error');
    }
    const { code, msg, showToast } = response.data;
    console.log('进入222')
    // 状态异常
    if (!code) {
      return response.data;
    }
    if (code != 200) {
      handleMessage(msg, 'error');
    }
    //后端接口需要显示提示
    if (showToast) {
      handleMessage(msg, 'success');
    }
    // 未登陆
    if (code == 201) {
      router.push('/login')
    }
    return response.data;
  },
  error => {

    if (loadingInstance) {
      loadingInstance.close()
    }
    console.log('进入')


    const { response } = error;
    if (response) {
      const { code, msg } = response.data;
      if (code !== 200) {
        handleMessage(msg, 'error');
      }
      return response.data;
    } else {
      console.error('Request failed:', error);
      handleMessage(error.message, 'error');
      return Promise.reject(error);
    }
  },
);

export default service
